(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-guide-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-guide-dialog')) {
    class SizeGuideDialog extends HTMLElement {
      connectedCallback() {
        this.openButton = this.querySelector('[data-size-guide-open]');
        this.dialog = this.querySelector('dialog');
        this.closeButton = this.querySelector('[data-size-guide-close]');

        if (!this.openButton || !this.dialog || !this.closeButton) {
          return;
        }

        this.handleOpen = this.openDialog.bind(this);
        this.handleCloseButton = this.closeDialog.bind(this);
        this.handleBackdropClick = this.closeOnBackdropClick.bind(this);
        this.handleDialogClose = this.restoreFocus.bind(this);

        this.openButton.addEventListener('click', this.handleOpen);

        this.closeButton.addEventListener(
          'click',
          this.handleCloseButton
        );

        this.dialog.addEventListener(
          'click',
          this.handleBackdropClick
        );

        this.dialog.addEventListener(
          'close',
          this.handleDialogClose
        );
      }

      disconnectedCallback() {
        if (!this.openButton || !this.dialog || !this.closeButton) {
          return;
        }

        this.openButton.removeEventListener(
          'click',
          this.handleOpen
        );

        this.closeButton.removeEventListener(
          'click',
          this.handleCloseButton
        );

        this.dialog.removeEventListener(
          'click',
          this.handleBackdropClick
        );

        this.dialog.removeEventListener(
          'close',
          this.handleDialogClose
        );

        if (this.dialog.open) {
          document.body.classList.remove(
            'size-guide-modal-open'
          );
        }
      }

      openDialog() {
        if (this.dialog.open) {
          return;
        }

        this.dialog.showModal();

        document.body.classList.add(
          'size-guide-modal-open'
        );

        window.requestAnimationFrame(() => {
          this.closeButton.focus();
        });
      }

      closeDialog() {
        if (this.dialog.open) {
          this.dialog.close();
        }
      }

      closeOnBackdropClick(event) {
        const dialogBounds =
          this.dialog.getBoundingClientRect();

        const clickIsInsideDialog =
          event.clientX >= dialogBounds.left &&
          event.clientX <= dialogBounds.right &&
          event.clientY >= dialogBounds.top &&
          event.clientY <= dialogBounds.bottom;

        if (!clickIsInsideDialog) {
          this.closeDialog();
        }
      }

      restoreFocus() {
        document.body.classList.remove(
          'size-guide-modal-open'
        );

        if (this.openButton.isConnected) {
          this.openButton.focus();
        }
      }
    }

    customElements.define(
      'size-guide-dialog',
      SizeGuideDialog
    );
  }
  } catch(e) { console.error(e); }
})();

})();
